module.exports = __webpack_public_path__ + "static/media/photo10.d596f7db.jpg";